import { Injectable } from "@angular/core";
import { Observable, catchError, retry } from "rxjs";
import { GeografiaNode } from "src/app/_core/models/geografia/geografia-node.model";
import { ApiEnum, HttpDataService } from "./http-data.service";

/**
 * Acceso al arbol geografico (Dama_Geografia) para el control "Ubicacion" del centro.
 * Carga perezosa: raiz por pais -> hijos por nodo. Ver ADR-0010.
 */
@Injectable({ providedIn: "root" })
export class GeografiaService {
	private readonly base = "/Geografia";

	constructor(private readonly httpDataService: HttpDataService) {}

	/** Nodo raiz (PAIS) por ISO-2; punto de entrada del arbol filtrado al pais del contrato. */
	getRaizPais(codigoPais: string): Observable<GeografiaNode> {
		return this.httpDataService
			.get$<GeografiaNode>(ApiEnum.API_ROOT, `${this.base}/RaizPais`, {
				codigoPais,
			})
			.pipe(
				retry(2),
				catchError(
					this.httpDataService.handleError<GeografiaNode>(
						"getRaizPais",
						null,
					),
				),
			);
	}

	/** Hijos directos de un nodo (expansion perezosa). */
	getHijos(padreId: number): Observable<GeografiaNode[]> {
		return this.httpDataService
			.get$<GeografiaNode[]>(ApiEnum.API_ROOT, `${this.base}/Hijos`, {
				padreId,
			})
			.pipe(
				retry(2),
				catchError(
					this.httpDataService.handleError<GeografiaNode[]>(
						"getHijosGeografia",
						[],
					),
				),
			);
	}

	/** Ruta de ancestros (pais -> ... -> nodo) para preseleccionar/expandir hasta una seleccion. */
	getRuta(id: number): Observable<GeografiaNode[]> {
		return this.httpDataService
			.get$<GeografiaNode[]>(ApiEnum.API_ROOT, `${this.base}/Ruta`, { id })
			.pipe(
				retry(2),
				catchError(
					this.httpDataService.handleError<GeografiaNode[]>(
						"getRutaGeografia",
						[],
					),
				),
			);
	}

	/** Búsqueda por nombre dentro del país: nodos seleccionables con su ruta (para el buscador). */
	buscar(codigoPais: string, texto: string): Observable<GeografiaNode[]> {
		return this.httpDataService
			.get$<GeografiaNode[]>(ApiEnum.API_ROOT, `${this.base}/Buscar`, {
				codigoPais,
				texto,
			})
			.pipe(
				retry(1),
				catchError(
					this.httpDataService.handleError<GeografiaNode[]>(
						"buscarGeografia",
						[],
					),
				),
			);
	}

	/** Un nodo concreto. */
	getById(id: number): Observable<GeografiaNode> {
		return this.httpDataService
			.get$<GeografiaNode>(
				ApiEnum.API_ROOT,
				`${this.base}/GetById/{id}`,
				{ id },
			)
			.pipe(
				retry(2),
				catchError(
					this.httpDataService.handleError<GeografiaNode>(
						"getByIdGeografia",
						null,
					),
				),
			);
	}
}
